// src/App.jsx
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.scss";
import HomePage from "./components/Home";
import LeadPage from "./components/Lead";
import CantQuote from "./components/Error";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <>
        <Routes>
          <Route path="/summary" element={<LeadPage />} />
          <Route path="/error" element={<CantQuote />} />
          <Route path="/" element={<HomePage />} />
          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        {/* Toast container goes outside Routes, so it's always available */}
        <ToastContainer
          position="top-center"
          autoClose={10000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{
            fontSize: "16px",
            maxWidth: "600px",
            margin: "auto",
            textAlign: "center",
          }}
        />
      </>
    </Router>
  );
}

export default App;
